import React, {
  Children,
  ReactElement,
  ReactNode,
  isValidElement,
} from "react";
import { FiEdit3 } from "@react-icons/all-files/fi/FiEdit3";
import { Stack } from "@chakra-ui/react";
import { TaskGroupContext } from "./Task";
import { TaskWrapper } from "./TaskWrapper";
import { useFlash } from "./utils";

type TaskGroupProps = {
  children: ReactNode;
  title?: string;
};

export function TaskGroup({ children, title = "Todo list" }: TaskGroupProps) {
  const flash = useFlash();

  const taskIds = Children.toArray(children)
    .filter(isValidElement)
    .map((child) => (child as ReactElement).props.taskId);

  return (
    <TaskWrapper
      icon={FiEdit3}
      isComplete={false}
      title={title}
      data-tasks={taskIds.join(" ")}
      {...flash}
    >
      <TaskGroupContext.Provider value={{ isGroup: true }}>
        <Stack>{children}</Stack>
      </TaskGroupContext.Provider>
    </TaskWrapper>
  );
}
